import React, { type ReactNode } from 'react'

import styled, { css } from 'styled-components'

import { AlertsLegendItem, LegendItem } from 'types/RuntimeHistory'

import { color } from 'styles/colors'

type Props = {
  isSelected?: boolean
  series: LegendItem | AlertsLegendItem
  getLegendDataCallback: (e: string) => ReactNode
  styled?: boolean
}
const HoveredSeriesValue = ({ isSelected = false, series, getLegendDataCallback, styled = true }: Props) => {
  return (
    <>
      {styled
        ? (
          <S.HoveredChartValue selected={isSelected} seriesName={series.seriesName} data-testid={series.seriesName}>
            {getLegendDataCallback(series.seriesName)}
          </S.HoveredChartValue>
        )
        : (
          <S.HoveredChartValueWithoutStyle data-testid={series.seriesName}>
            {getLegendDataCallback(series.seriesName)}
          </S.HoveredChartValueWithoutStyle>
        )
    }
    </>

  )
}

export default HoveredSeriesValue

const S = {
  HoveredChartValue: styled.span.withConfig({
    shouldForwardProp: (prop) => !['selected', 'seriesName'].includes(prop)
  })<{ selected: boolean, seriesName: string }>`
    text-align: center;
    display: inline-block;
    ${({ selected }) => (selected) ? 'font-weight: bold;' : null}
    ${({ seriesName }) => (seriesName === 'cooling' || seriesName === 'heating') && css`
      font-weight: 600;
      border-radius: 5px;
      width: 37px;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      border-radius: 5px;
      color: ${color('primaryButtonText')};
    `}
    ${({ seriesName }) => seriesName === 'heating' && css`background: ${color('pillHeating')};`}
    ${({ seriesName }) => seriesName === 'cooling' && css`background: ${color('pillCooling')};`}
  `,
  HoveredChartValueWithoutStyle: styled.span`
    font-weight: 400;
    color: ${color('tooltipBorder')};
  `
}
